module.exports = __webpack_public_path__ + "static/image/service/pc/store.jpg?c7f2e3de";